import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../../contexts/halfYearContext";
import { PopUpContext } from "../../../../contexts/popUpContext";

import MainButton from "../../../common/MainButton";
import MainTitle from "../../../common/MainTitle";
import DataTable from "./AccountsListTable";
import TableMainSearch from "../../../common/MainSearch";

import db from "../../../../services/query";
import lbl from "../../../../data/Labels.json";

const BudgetAccountsList = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  const { aid } = props.match.params;

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `revenues/budget/accounts/${aid}?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainButton
            title={lbl.SaveBudget}
            handleClick={() =>
              togglePopUp({ form: "revenue-budget-form", aid })
            }
            type={"budget"}
          />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default BudgetAccountsList;
